import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "@/lib/analytics";

/** Mount once inside <BrowserRouter>; reports a PostHog $pageview per route. */
export default function PageViewTracker() {
  const { pathname } = useLocation();
  useEffect(() => { capturePageview(pathname); }, [pathname]);
  return null;
}
